import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import CertificationPhoto from '../../assets/images/program-builder/junior-with-coach.webp'

import classes from './CertificationStep.module.scss'

const BENEFIT_KEYS = [
  'portal.gettingStarted.certification.benefits.coFounders',
  'portal.gettingStarted.certification.benefits.recipe',
  'portal.gettingStarted.certification.benefits.enrollments',
  'portal.gettingStarted.certification.benefits.optional',
]

const CertificationStep = ({ certified, skippable, isSaving, onSkip }) => {
  const { t } = useTranslation()

  return (
    <div className={classes.step}>
      <h3 className={classes.headline}>{t('portal.gettingStarted.certification.headline')}</h3>
      <p className={classes.text}>{t('portal.gettingStarted.certification.body')}</p>
      <div className={classes.grid}>
        <div className={classNames('position-relative', classes.tile)}>
          <img src={CertificationPhoto} alt='' className={classes.photo} />
          <span className={classes.tileLabel}>
            <i className='fa fa-graduation-cap mr-2' aria-hidden='true' />
            {t('portal.gettingStarted.certification.tileLabel')}
          </span>
        </div>
        <div className='d-flex flex-column'>
          <ul className='list-unstyled mb-0'>
            {BENEFIT_KEYS.map(benefitKey => (
              <li key={benefitKey} className={classNames('d-flex align-items-start', classes.benefit)}>
                <i className='fa fa-check' aria-hidden='true' />
                {t(benefitKey)}
              </li>
            ))}
          </ul>
          <div className={classNames('d-flex align-items-center flex-wrap mt-auto', classes.actions)}>
            {certified ? (
              <span className={classNames('d-flex align-items-center', classes.completed)}>
                <i className='fa fa-check-circle mr-2' aria-hidden='true' />
                {t('portal.gettingStarted.certification.completed')}
              </span>
            ) : (
              <Link to='/portal/certifications' className={classNames('btn btn-primary text-white', classes.startButton)}>
                <i className='fa fa-graduation-cap mr-2' aria-hidden='true' />
                {t('portal.gettingStarted.certification.start')}
              </Link>
            )}
            {skippable && (
              <button type='button' className={classes.skipButton} onClick={onSkip} disabled={isSaving}>
                {t('portal.gettingStarted.certification.skip')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

CertificationStep.propTypes = {
  certified: PropTypes.bool.isRequired,
  skippable: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  onSkip: PropTypes.func.isRequired,
}

export default CertificationStep
